import React from 'react'
import PropTypes from 'prop-types'

const NameSort = (props) => {
  let classArrow = ''
  const dataFilter = {
    active: 'name',
  }
  if (props.liveDataFilter.active === 'name') {
    classArrow = props.liveDataFilter.sort.toLowerCase()
  }

  if (props.liveDataFilter.sort === 'ASC') {
    dataFilter.sort = 'DESC'
  } else {
    dataFilter.sort = 'ASC'
  }

  return (
    <button className={`sort-header ${classArrow}`} onClick={props.sortLiveData(dataFilter)} >Name</button>
  )
}

NameSort.propTypes = {
  liveDataFilter: PropTypes.shape({
    active: PropTypes.string,
    sort: PropTypes.string,
  }).isRequired,
  sortLiveData: PropTypes.func.isRequired,
}

export default NameSort
